export default __webpack_public_path__ + "static/SR USA - Application Guide for Liquid Caramel Colors-85c4172fbf508b2d8fee328cd99806d8.pdf";